import { render } from "./headerCom1.vue?vue&type=template&id=5204edc0"
import script from "./headerCom1.vue?vue&type=script&lang=js"
export * from "./headerCom1.vue?vue&type=script&lang=js"

import "./headerCom1.vue?vue&type=style&index=0&id=5204edc0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__